module.exports = __webpack_public_path__ + "media/images/example_qr-229d17170e42abd642b171356f3dea7e.png";